"use client";

import Script from "next/script";
import {useEffect, useState} from "react";

const IS_RUMBLE = process.env.NEXT_PUBLIC_PLATFORM === "rumble";

export function AdSenseScript() {
    const [shouldLoadAds, setShouldLoadAds] = useState(IS_RUMBLE);

    useEffect(() => {
        if (IS_RUMBLE) {
            return;
        }

        try {
            const storedLicenseKey = window.localStorage.getItem("license_key");
            const queryLicenseKey = new URLSearchParams(window.location.search).get("license_key");
            const hasStoredLicenseKey = !!storedLicenseKey && storedLicenseKey !== "null" && storedLicenseKey !== '""';

            setShouldLoadAds(!hasStoredLicenseKey && !queryLicenseKey);
        } catch (error) {
            console.error("Failed to check license before loading ads", error);
        }
    }, []);

    if (!shouldLoadAds) {
        return null;
    }

    return (
        <Script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1207989483928519"
            crossOrigin="anonymous"
        />
    );
}
